import * as React from 'react';
import { Lightbulb } from 'lucide-react';
import { Pack } from '../../types/landing';
import { Slider } from './Slider';
import { PackCard } from './PackCard';
import { route } from '../../utils/route';

interface SolutionsSliderProps {
  solutions: Pack[];
}

export function SolutionsSlider({ solutions }: SolutionsSliderProps): React.ReactElement {
  return (
    <div className="solutions-slider-wrapper">
      <style>{`
        .solutions-slider-wrapper {
          background: #f8f9fa;
        }

        .solutions-slider-wrapper .slider-section {
          background: transparent;
        }
      `}</style>

      <Slider
        title="Nuestras Soluciones"
        shortTitle="Soluciones"
        icon={<Lightbulb size={24} />}
        viewAllLink={route('solutions.index')}
        viewAllText="Ver todas las soluciones"
      >
        {solutions.map(solution => (
          <PackCard
            key={solution.id}
            pack={solution}
            detailUrl={route('solutions.show', { id: solution.slug || solution.id })}
          />
        ))}
      </Slider>
    </div>
  );
}
